import { flow } from 'lodash'
import ContentCopyIcon from 'mdi-react/ContentCopyIcon'
import React, { useMemo } from 'react'
import { Column } from 'react-table'

import { Avatar, Button, ButtonGroup, useMediaQuery, useTheme } from '@mui/material'

import { history } from '../../../../../../duck/store'
import { Corporate } from '../../../../../../entities-next/corporate'
import { insertIf } from '../../../../../../utils-next/arrays'
import { SCOUTING_CAMPAIGN_MANAGER_LIST_PATH } from '../../../ScoutingCampaignManager'
import { USER_MANAGER_LIST_PATH } from '../../../UsersManager'

export function useCorporateDataRows(extraRows: Column<Corporate>[]): Column<Corporate>[] {
  const theme = useTheme()
  const mediumScreenSize = useMediaQuery(theme.breakpoints.up('sm'))
  const largeScreenSize = useMediaQuery(theme.breakpoints.up('lg'))

  return useMemo(() => [...baseUserRowData(), ...insertIf(largeScreenSize, extraRowData()), ...extraRows], [
    theme,
    extraRows,
    largeScreenSize,
    mediumScreenSize,
  ]) as any
}

const baseUserRowData = () => [
  {
    Header: 'Id',
    accessor: getCorporateId,
    maxWidth: 32,
  },
  {
    Header: 'Logo',
    accessor: getCorporatePicture,
    maxWidth: 12,
  },
  {
    Header: 'Name',
    accessor: flow(getCorporateName),
  },
  {
    Header: 'Status',
    accessor: flow(getStatus),
    maxWidth: 24,
  },
]

const extraRowData = () => [
  {
    Header: 'Users',
    accessor: getUserButton,
    maxWidth: 24,
  },
  {
    Header: 'Spaces',
    accessor: getScoutingCampaignButton,
    maxWidth: 44,
  },
]

function getCorporateId({ id }: Corporate) {
  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    navigator.clipboard.writeText(id.toString())
    e.stopPropagation()
  }
  return (
    <ButtonGroup variant="contained" aria-label="outlined primary button group">
      <Button variant="contained" size="small" color="info" title="Go to details">
        {id}
      </Button>
      <Button color="info" size="small" onClick={handleCopy} title="Copy id to clipboard">
        <ContentCopyIcon size={16} />
      </Button>
    </ButtonGroup>
  )
}

function getCorporatePicture(corporate: Corporate) {
  const name = flow(getCorporateName)
  return <Avatar src={corporate.logoUrl} alt={`${name}'s logo`} />
}

function getCorporateName({ id, name }: Corporate) {
  return `${name} (${id})`
}

function getStatus({ status }: Corporate) {
  return status.charAt(0).toUpperCase() + status.slice(1)
}

function getUserButton({ id }: Corporate) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    history.push(`${USER_MANAGER_LIST_PATH}?corporateId=${id}`)
    e.stopPropagation()
  }
  return (
    <Button variant="contained" color="info" size="small" onClick={handleClick}>
      Users
    </Button>
  )
}
function getScoutingCampaignButton({ id }: Corporate) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    history.push(`${SCOUTING_CAMPAIGN_MANAGER_LIST_PATH}?corporateId=${id}`)
    e.stopPropagation()
  }
  return (
    <Button variant="contained" color="info" size="small" onClick={handleClick}>
      Spaces
    </Button>
  )
}
